import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form, Icon } from 'semantic-ui-react';
import { InputMode } from 'Common/FormEnum';
import { FieldEnum } from 'Common/FieldEnum';
import { DropdownObjectCreator, SiteObjectHelper } from 'Common/ObjectHelper';
import { SelectField, InputField, CheckboxField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { SERVING_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import {
  restrictionsOptions,
  frequencyOptions,
} from '../helpers/SiteSetupConstants';
import { TitledCard } from 'Components';

let defaultCharges = [
  { key: 'M', value: 'M', text: 'M  Meals Only' },
  { key: 'K', value: 'K', text: 'K  Milk Only' },
  { key: 'B', value: 'B', text: 'B  Meals & Milk Only' },
  { key: 'Y', value: 'Y', text: 'Y  Allow Charges' },
  { key: 'N', value: 'N', text: 'N  No Charges' },
];

let lunchOptions = [],
  breakfastOptions = [],
  supperOptions = [],
  sitesOptions = [];

class ServingConfiguration extends Component {
  constructor(props) {
    super();
    this.state = {
      alaCarteDisabled: props.alaCarteDisabled,
      servedItemsLength: 0,
    };
  }

  AlaCarteChange = restriction => {
    this.props.change(FieldEnum.AlaCarteExpense, restriction);
    if (restriction === 'Y') {
      this.setState({ alaCarteDisabled: true });
    } else {
      this.setState({ alaCarteDisabled: false });
    }
  };

  componentWillReceiveProps(nextProps) {
    const { servedItems, servingSitesInfo, ownSiteId } = nextProps;
    if (this.state.servedItemsLength === 0 && servedItems) {
      sitesOptions =
        servingSitesInfo &&
        servingSitesInfo.Data &&
        servingSitesInfo.Data.length > 0
          ? SiteObjectHelper(servingSitesInfo.Data, ownSiteId)
          : [];
      let emptyOption = [{ key: 'empty', value: '', text: '' }];
      breakfastOptions =
        servedItems.BreakFast &&
        servedItems.BreakFast.length > 0 &&
        DropdownObjectCreator(
          servedItems.BreakFast,
          'Id',
          'ShortDescription',
          true
        );
      lunchOptions =
        servedItems.Lunch &&
        servedItems.Lunch.length > 0 &&
        DropdownObjectCreator(
          servedItems.Lunch,
          'Id',
          'ShortDescription',
          true
        );
      supperOptions =
        servedItems.Supper &&
        servedItems.Supper.length > 0 &&
        DropdownObjectCreator(
          servedItems.Supper,
          'Id',
          'ShortDescription',
          true
        );
      breakfastOptions = [...emptyOption, ...breakfastOptions];
      lunchOptions = [...emptyOption, ...lunchOptions];
      supperOptions = [...emptyOption, ...supperOptions];
      this.setState({ servedItemsLenght: servedItems.length });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Fragment>
        <Form onSubmit={handleSubmit}>
          <Grid padded>
            <Grid.Row>
              <TitledCard title={''}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.ServingSite}
                        component={SelectField}
                        type="text"
                        label={'Primary Serving Site'}
                        options={sitesOptions}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Field
                        name={FieldEnum.AttendanceFactor}
                        component={InputField}
                        type="text"
                        numericSize={[5, 2]}
                        label={'Attendance Factor'}
                        icon={<Icon name="percent" />}
                        mode={InputMode.Decimal}
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Field
                        name={FieldEnum.ChargeFlag}
                        component={SelectField}
                        type="text"
                        label={'Default Charge'}
                        options={defaultCharges}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.SevereNeed}
                        component={CheckboxField}
                        toggle
                        label={'Severe Need'}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.AreaEligible}
                        component={CheckboxField}
                        toggle
                        label={'Area Eligible'}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>
              <TitledCard title={'Offer Vs. Serve Meal'}>
                <Grid>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <Field
                        name={FieldEnum.BreakfastId}
                        component={SelectField}
                        type="text"
                        label={'Breakfast'}
                        options={breakfastOptions}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        name={FieldEnum.LunchId}
                        component={SelectField}
                        type="text"
                        label={'Lunch'}
                        options={lunchOptions}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        name={FieldEnum.SupperId}
                        component={SelectField}
                        type="text"
                        label={'Supper'}
                        options={supperOptions}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>
              <TitledCard title={'Extra Credit'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.AdditionalCredit}
                        component={InputField}
                        type="text"
                        maxLength={6}
                        label={'ADDITIONAL CREDIT'}
                        icon={<Icon name="percent" />}
                        mode={InputMode.Decimal}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.MinimumPayment}
                        component={InputField}
                        type="text"
                        maxLength={6}
                        label={'MINIMUM PAYMENT'}
                        iconPosition={'left'}
                        icon={<Icon name="dollar" />}
                        mode={InputMode.Decimal}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>
              <TitledCard title={'A la Carte Purchases'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        label={''}
                        options={restrictionsOptions}
                        formName={SERVING_CONFIGURATION_FORM_NAME}
                        fieldName={FieldEnum.AlaCarteExpense}
                        onChange={this.AlaCarteChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    {this.state.alaCarteDisabled && (
                      <Grid.Column width={4}>
                        <Field
                          name={FieldEnum.AlaCarteAmount}
                          component={InputField}
                          type="text"
                          label={' '}
                          maxLength={6}
                          iconPosition={'left'}
                          icon={<Icon name="dollar" />}
                          mode={InputMode.Decimal}
                        />
                      </Grid.Column>
                    )}
                    {this.state.alaCarteDisabled && (
                      <Fragment>
                        <Grid.Column
                          width={12}
                          className="input-group--btn-group"
                        >
                          <ReduxFormButtonGroup
                            label={''}
                            options={frequencyOptions}
                            formName={SERVING_CONFIGURATION_FORM_NAME}
                            fieldName={FieldEnum.AlaCarteExpFrequency}
                          />
                        </Grid.Column>
                      </Fragment>
                    )}
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const errorMessage = 'Please Enter a valid Number';

const validate = (values, props) => {
  const errors = {};
  if (
    values[FieldEnum.AdditionalCredit] &&
    isNaN(values[FieldEnum.AdditionalCredit])
  ) {
    errors[FieldEnum.AdditionalCredit] = errorMessage;
  }
  if (
    values[FieldEnum.MinimumPayment] &&
    isNaN(values[FieldEnum.MinimumPayment])
  ) {
    errors[FieldEnum.MinimumPayment] = errorMessage;
  }
  if (
    values[FieldEnum.AttendanceFactor] &&
    isNaN(values[FieldEnum.AttendanceFactor])
  ) {
    errors[FieldEnum.AttendanceFactor] = errorMessage;
  }
  if (
    values[FieldEnum.AlaCarteAmount] &&
    isNaN(values[FieldEnum.AlaCarteAmount])
  ) {
    errors[FieldEnum.AlaCarteAmount] = errorMessage;
  }

  return errors;
};

export default reduxForm({
  validate,
  enableReinitialize: true,
  form: SERVING_CONFIGURATION_FORM_NAME,
})(ServingConfiguration);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/ServingConfiguration.js